import {
  safelyGetStorageItem,
  safelySetStorageItem
} from '../../../_web/utils/persistence'
import {OffersConfigurations} from '../../../api-types/bovio/response/offers_configurations'
import {safeJsonParse} from '../../../utils/object'

const CONFIGURATION_STORAGE_KEY = 'boVioConfiguration'

const listeners = new Set<() => void>()
let configurationVersion = 0

export const subscribeToConfiguration = (listener: () => void) => {
  listeners.add(listener)
  return () => {
    listeners.delete(listener)
  }
}

export const getConfigurationVersion = () => configurationVersion

/**
 * Get the BoVio persisted configuration from the session storage.
 */
export const getPersistedConfiguration = () => {
  return (safeJsonParse(
    safelyGetStorageItem(sessionStorage, CONFIGURATION_STORAGE_KEY)
  ) || {}) as OffersConfigurations
}

export const persistConfiguration = (data: OffersConfigurations) => {
  const result = safelySetStorageItem(
    sessionStorage,
    CONFIGURATION_STORAGE_KEY,
    JSON.stringify(data)
  )
  configurationVersion += 1
  listeners.forEach(listener => listener())
  return result
}
